"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickFromUnion = exports.maybeGet = exports.deleteUndefined = exports.assertUnreachable = exports.isKeyOf = void 0;
const arrayHelpers_1 = require("./arrayHelpers");
const objectHelpers_1 = require("./objectHelpers");
const isKeyOf = (x, props) => {
    return typeof x === 'string' && x in props ? true : false;
};
exports.isKeyOf = isKeyOf;
/**
 * Use this function to confirm that a `switch` statement is exhaustive
 * @param x
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const assertUnreachable = (x) => {
    console.log({ x });
    throw new Error("Didn't expect to get here");
};
exports.assertUnreachable = assertUnreachable;
function deleteUndefined(x, recursive = true) {
    if (!x)
        return x !== null && x !== void 0 ? x : null;
    if (Array.isArray(x)) {
        if (recursive) {
            return x.map((v) => deleteUndefined(v));
        }
    }
    else {
        Object.keys(x).forEach((k) => {
            if (x[k] === undefined) {
                delete x[k];
            }
            else if (recursive && x[k] && ['object', 'array'].includes(typeof x[k])) {
                x[k] = deleteUndefined(x[k]);
            }
        });
    }
    Object.keys(x).forEach((k) => {
        if (x[k] === undefined) {
            delete x[k];
        }
    });
    return x;
}
exports.deleteUndefined = deleteUndefined;
function maybeGet(props, selection) {
    var _a;
    if ((0, arrayHelpers_1.isArray)(selection))
        return selection.reduce((results, key) => {
            results[key] = maybeGet(props, key);
            return results;
        }, {});
    return props && selection in props ? (_a = props[selection]) !== null && _a !== void 0 ? _a : undefined : undefined;
}
exports.maybeGet = maybeGet;
/**
 * Augments an object so that Union properties K, are added to T as undefined values, where absent
 */
const pickFromUnion = (props, selection) => {
    const extras = maybeGet(props, selection);
    return (0, objectHelpers_1.removeNullValues)(Object.assign(Object.assign({}, props), extras));
};
exports.pickFromUnion = pickFromUnion;
